import * as THREE from 'three';
import type { MaterialLibrary } from '../MaterialLibrary';

export type SoldierModel = {
  root: THREE.Group;
  body: THREE.Object3D;
  muzzleSocket: THREE.Object3D;
  radius: number;
};

export class SoldierFactory {
  constructor(private readonly materials: MaterialLibrary) {}

  create(): SoldierModel {
    const root = new THREE.Group();
    root.name = 'soldier';

    const body = new THREE.Mesh(new THREE.CapsuleGeometry(0.16, 0.32, 4, 8), this.materials.olive);
    body.position.y = 0.38;
    body.castShadow = true;
    root.add(body);

    const head = new THREE.Mesh(new THREE.SphereGeometry(0.13, 8, 8), this.materials.darkOlive);
    head.position.y = 0.72;
    head.castShadow = true;
    root.add(head);

    const helmet = new THREE.Mesh(
      new THREE.SphereGeometry(0.15, 8, 8, 0, Math.PI * 2, 0, Math.PI / 2),
      this.materials.olive,
    );
    helmet.position.y = 0.74;
    helmet.castShadow = true;
    root.add(helmet);

    const rifle = new THREE.Mesh(new THREE.BoxGeometry(0.05, 0.05, 0.46), this.materials.darkSteel);
    rifle.position.set(0.1, 0.48, 0.16);
    rifle.rotation.y = 0.2;
    rifle.castShadow = true;
    root.add(rifle);

    const muzzleSocket = new THREE.Object3D();
    muzzleSocket.position.set(0.1, 0.48, 0.42);
    root.add(muzzleSocket);

    return { root, body, muzzleSocket, radius: 0.22 };
  }
}
